/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteThemeInput = {
    id: string;
};
export type apiDeleteThemeAndDependenciesMutationVariables = {
    input: DeleteThemeInput;
};
export type apiDeleteThemeAndDependenciesMutationResponse = {
    readonly deleteThemeAndDependencies: {
        readonly status: string;
        readonly unitCount: number | null;
        readonly themeGroupCount: number | null;
    };
};
export type apiDeleteThemeAndDependenciesMutation = {
    readonly response: apiDeleteThemeAndDependenciesMutationResponse;
    readonly variables: apiDeleteThemeAndDependenciesMutationVariables;
};



/*
mutation apiDeleteThemeAndDependenciesMutation(
  $input: DeleteThemeInput!
) {
  deleteThemeAndDependencies(input: $input) {
    status
    unitCount
    themeGroupCount
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteThemePayload",
    "kind": "LinkedField",
    "name": "deleteThemeAndDependencies",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unitCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "themeGroupCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "apiDeleteThemeAndDependenciesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "apiDeleteThemeAndDependenciesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1db3812863c6c42e89edccbdb3eb1721",
    "id": null,
    "metadata": {},
    "name": "apiDeleteThemeAndDependenciesMutation",
    "operationKind": "mutation",
    "text": "mutation apiDeleteThemeAndDependenciesMutation(\n  $input: DeleteThemeInput!\n) {\n  deleteThemeAndDependencies(input: $input) {\n    status\n    unitCount\n    themeGroupCount\n  }\n}\n"
  }
};
})();
(node as any).hash = '377daa486fbee67c6a78985466789360';
export default node;
